<template>
  <div>
    <div class="row">
      <div class="col-6">
        <i class="ml-2 bi bi-question-circle-fill" data-toogle="tooltip" title="This plot has a zoom functionality"
           v-bind:style="{ fontSize : '15px'}" v-b-tooltip.hover></i>
      </div>
      <div class="col-6" v-bind:style="{ width:'100%', textAlign: 'right', paddingRight:'20px' }">
        <i class=" mr-1 bi bi-sliders" data-toogle="tooltip" title="Settings" v-b-modal="componentId+'-modal'"
           v-bind:style="{ fontSize : '15px'}"></i>
        <i class=" mr-1 bi bi-card-text"  data-toogle="tooltip" title="Legend" v-bind:style="{fontSize : '15px'}" v-b-modal="componentId+'-legend'"></i>
        <i class="mr-1 bi bi-save-fill"  data-toogle="tooltip" title="Export" v-bind:style="{ fontSize : '12px'}"
           v-b-modal="componentId+'-modal-save'"></i>
        <i class=" mr-1 bi bi-files" data-toogle="tooltip" title="Duplicate" v-on:click="cloneCurrentWidget"
           v-bind:style="{ fontSize : '12px'}"></i>
      </div>
    </div>
    <div class="widget-legend legend">
      <span :id="componentId+'plot_title'">Evolution of relative abundances of {{ taxon }} in % between {{
          dateStart
        }} and
        {{ dateEnd }} on fraction {{ fraction }} µm</span>
    </div>
    <DateGraphWidget :plotData="plotData" :componentId="componentId" :advanced="advanced">
    </DateGraphWidget>

    <b-modal :id="componentId+'-modal'" title="Annual distribution">
      <div class="form-group mt-2" style="font-size: 1.6vmin;">
        <div class="form-group mt-2">
          <template>
            <b-form-group label="Representation by" v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                  :id="componentId+'radio-group-1'"
                  v-model="representation"
                  :options="representationOptions"
                  :aria-describedby="ariaDescribedby"
                  name="plot-options"
              ></b-form-radio-group>
            </b-form-group>
          </template>
        </div>
        <div class="form-group mt-2">
          <div v-if="representation === 'taxon' || representation === 'count'">
            <b-form-group label="Taxon">
              <select v-model="taxon" class="form-control">
                <optgroup v-for="(names, group) in taxons" v-bind:key="group" :label="`${group}`">
                  <option v-for="option in names" v-bind:key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </optgroup>
              </select>
            </b-form-group>
          </div>
          <div v-if="representation === 'asv'">
            <b-form-group label="ASV">
              <select v-model="asv" class="form-control" multiple>
                <optgroup v-for="(names, group) in asvs" v-bind:key="group" :label="`${group}`">
                  <option v-for="option in names" v-bind:key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </optgroup>
              </select>
            </b-form-group>
          </div>
          <div class="form-group mt-2">
            <b-form-group label="Depth">
              <select v-model="depth" class="form-control">
                <option v-for="option in depthCodes" v-bind:key="option.depth" :value="option.depth">
                  {{ option.depth }}
                </option>
              </select>
            </b-form-group>
          </div>

          <div class="form-group mt-2">
            <template>
              <b-form-group label="Fraction size" v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                    :id="componentId+'radio-group-2'"
                    v-model="fraction"
                    :options="fractions"
                    :aria-describedby="ariaDescribedby"
                    name="fraction-options"
                ></b-form-radio-group>
              </b-form-group>
            </template>
          </div>
        </div>
        <div>
          <b-form-checkbox
              :id="componentId+'advanced'"
              v-model="advanced"
              name="advanced_splitting"
              value="checked"
              unchecked-value="not_checked"
          >
            Advanced Splitting
          </b-form-checkbox>
        </div>
        <div class="form-group mt-2" style="font-size: 1.6vmin;" v-if="advanced === 'checked'">
          <template>
            <b-form-group label="Splitting : " v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                  :id="componentId+'radio-group-advanced'"
                  v-model="splitBy"
                  :options="advancedSplittingOptions"
                  :aria-describedby="ariaDescribedby"
                  name="split-options"
              ></b-form-radio-group>
            </b-form-group>
          </template>
        </div>
      </div>
    </b-modal>
    <b-modal :id="componentId+'-legend'" title="Legend">
      HTML allowed
      <textarea class="col-12" v-model="legend" placeholder="add multiple lines"></textarea>

      <b-button v-b-toggle="'collapse'+ componentId" variant="primary">Show/Hide</b-button>
    </b-modal>
    <ExportDialog :componentId="componentId" :formattedData="formattedData" :plotData="plotData"
                  :exportFileName="exportFileName"
                  :dataset="dataset" :legend="legend"></ExportDialog>
    <div>
      <b-collapse v-model="visible" :id="'collapse'+componentId" class="">
        <b-card>
          <div v-html="legend">
          </div>

        </b-card>
      </b-collapse>
    </div>

  </div>
</template>
<script>
import axios from "axios"
import DateGraphWidget from "./DateGraphWidget"
import {mapActions} from "vuex"
import {ApiCall} from "../mixins/ApiMixin";
import ExportDialog from "./ExportDialog.vue";

export default {
  name: "DateGraph",
  props: ['panelId', 'componentId', 'triggerValue', 'settings'],
  mixins: [ApiCall],
  data() {
    return {
      advancedSplittingOptions: [
        {text: 'By Depth', value: 'depth'},
        {text: 'By Year', value: 'year'},
        {text: 'By Cluster', value: 'cluster'},
      ],
      representationOptions: [],
      representation: null,
      dataset: null,
      datatype: null,
      advanced: "not_checked",
      splitBy: null,
      legend: null,
      rank: null,
      searchPanelTaxon: null,
      formattedData: null,
      dateStart: null,
      dateEnd: null,
      visible: false,
      taxon: null,
      taxons: {},
      asv: [],
      asvs: {},
      depthCodes: {},
      depth: null,

      fractions: [],
      fraction: null,

      plotData: null,

      settingsHash: "",
      exportFileName: "mygod_abundance_over_time",
      plotName: '-date_plot_area',

      apiCallsInProgress: 0
    }
  },

  components: {
    DateGraphWidget,
    ExportDialog
  },

  created: function () {
    this.updateContents()
  },

  watch: {

    triggerValue() {
      this.updateContents()
    },
    taxon() {
      this.getPlotData()
    },
    fraction() {
      this.getPlotData()
    },
    depth() {
      this.getPlotData()
    },

    asv() {
      this.getPlotData()
    },
    representation() {
      this.getPlotData()
    },
    advanced() {
      if (this.advanced === 'not_checked') {
        this.splitBy = null
      }
    },
    splitBy() {
      this.getPlotData()
    },
    legend() {
      this.updateDashboardWidgetLegend({
        'componentId': this.componentId,
        'legend': this.legend
      })
    },
    plotData() {
      this.reformatData()
    }
  },

  methods: {

    ...mapActions([
      'updateDashboardWidgetSettings',
      'cloneWidget',
      'updateDashboardWidgetLegend'
    ]),


    updateContents() {
      let panel = this.$store.state.panels[this.panelId]
      let newPanelSettingsHash = panel.dataset + panel.rank + panel.taxon + panel.dateStart + panel.dateEnd
      if (newPanelSettingsHash === this.settingsPanelHash) {
        return
      }
      this.settingsPanelHash = newPanelSettingsHash
      this.plotData = null

      this.dataset = panel.dataset
      this.rank = panel.rank
      this.searchPanelTaxon = panel.taxon
      this.dateStart = panel.dateStart
      this.dateEnd = panel.dateEnd


      this.initializeRepresentation()
      this.initializeLegend()
      this.initializeSplitBy()
      this.initializeFractionSizes()
      this.initializeDepthCode()
      this.getPlotData()
    },

    getPlotData() {
      if (this.apiCallsInProgress > 0) {
        setTimeout(this.getPlotData, 2000)
        return
      }
      if (this.dataset && this.fraction && this.dateStart && this.dateEnd && this.taxon && this.asv && this.depth && this.representation) {
        let asvString = this.asv
        let newSettingsHash = this.dataset + this.taxon + asvString + this.fraction + this.dateStart + this.dateEnd + this.depth + this.representation + this.splitBy
        if (newSettingsHash === this.settingsHash) {
          return
        }

        this.settingsHash = newSettingsHash
        this.plotData = null

        this.updateDashboardWidgetSettings({
          'componentId': this.componentId,
          'settings': {
            'dataset': this.dataset,
            'taxon': this.taxon,
            'asv': this.asv,
            'representation': this.representation,
            'fraction': this.fraction,
            'dateStart': this.dateStart,
            'dateEnd': this.dateEnd,
            'depth': this.depth,
            'splitBy': this.splitBy,
            'legend': this.legend,
            'advanced': this.advanced
          }
        })

        let me = this
        if (this.representation === "taxon" || this.representation === "count") {
          let taxonSelectValue = this.taxon
          let words = taxonSelectValue.split('@')
          let rank = words[0]
          let taxon = words[1]
          axios
              .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['occurrences_by_date_taxon',
              this.dataset,rank,taxon,this.fraction,this.dateStart,this.dateEnd,this.depth,this.representation,this.splitBy]))
              .then(function (response) {
                me.plotData = response.data
              })
        }
        if (this.representation === "asv") {
          let asvList = JSON.stringify(this.asv)
          axios
              .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['occurrences_by_date_asv',
                this.dataset,asvList,this.fraction,this.dateStart,this.dateEnd,this.depth,this.splitBy]))
              .then(function (response) {
                me.plotData = response.data
              })
        }
      } else {
        console.debug("getPlotData() " + this.componentId + ": undefined parameters, no actual data  retrieval attempted.")
      }
    },

  }

}


</script>

<style scoped>

</style>